export default __webpack_public_path__ + "static/media/angel-right-orange.7d9798f1.svg";